import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "资产变动记录")
  ])
], -1)
const _hoisted_3 = { class: "card-body py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChangeLogTable = _resolveComponent("ChangeLogTable")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_tabs, {
        modelValue: _ctx.activeTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: "余额变动",
            name: "balance"
          }, {
            default: _withCtx(() => [
              (_ctx.activeTab === 'balance')
                ? (_openBlock(), _createBlock(_component_ChangeLogTable, {
                    key: 0,
                    "log-type": "balance",
                    "show-user-column": true
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "点数变动",
            name: "point"
          }, {
            default: _withCtx(() => [
              (_ctx.activeTab === 'point')
                ? (_openBlock(), _createBlock(_component_ChangeLogTable, {
                    key: 0,
                    "log-type": "point",
                    "show-user-column": true
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_tab_pane, {
            label: "积分变动",
            name: "membership_point"
          }, {
            default: _withCtx(() => [
              (_ctx.activeTab === 'membership_point')
                ? (_openBlock(), _createBlock(_component_ChangeLogTable, {
                    key: 0,
                    "log-type": "membership_point",
                    "show-user-column": true
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}